import { useTranslations } from "next-intl";
import { Button } from "@components/core";

const AddressIndicator = ({ place, onChangeButtonClick }) => {
  const t = useTranslations("addresses");

  return (
    <div className="d-flex flex-row justify-content-between mb-1">
      <div>
        <p className="mb-0">{t("nearby_address")}</p>
        <p className="mb-0 font-weight-bold">{place?.formatted_address}</p>
      </div>
      <div>
        <Button
          variant="ghost-primary px-0 pt-0"
          onClick={onChangeButtonClick}
        >
          {t("modify")}
        </Button>
      </div>
    </div>
  );
};

export default AddressIndicator;
